export default __webpack_public_path__ + "images/cda789810fc58007cce1ed1775251d0e-Eventbrite_NYE_HomepageA_1920x544.webp";